<template>
<b-card title="Card Title" no-body>
    <b-card-header header-tag="nav">
      <b-nav card-header tabs>
        <!-- <b-nav-item>'s with child routes. Note the trailing slash on the first <b-nav-item> -->
        <b-nav-item to="/billing/" exact exact-active-class="active">Overview</b-nav-item>
        <b-nav-item to="/billing/subscription" exact exact-active-class="active">Subscription</b-nav-item>
        <b-nav-item to="/billing/payments" exact exact-active-class="active">Payment</b-nav-item>
        <b-nav-item to="/billing/history" exact exact-active-class="active">History</b-nav-item>
      </b-nav>
    </b-card-header>

    <b-card-body>
      <!-- child nav route renders here -->
      <router-view></router-view>
    </b-card-body>
  </b-card>
</template>

<script>

export default {
  components: {
  },
  props: {},
  data() {
    return {};
  },
  created() {
  },
  mounted() {
    // we inject stripe directly onto the billing page per the Stripe API Doc suggestions.
    // see: https://stripe.com/docs/js/including
    const injectedStripeScript = document.createElement('script');
    injectedStripeScript.setAttribute('src', 'https://js.stripe.com/v3/');
    document.head.appendChild(injectedStripeScript);
  },
  computed: {},
  methods: {

  },
};
</script>

<style scoped>

</style>
